import { useCallback } from 'react';
import { useInvoiceDrawerStore } from '@hero/hooks-shared';

/** Opens the shared {@link InvoiceDrawer} for a Hero invoice id. */
export function useOpenHeroInvoiceDrawer() {
  const open = useInvoiceDrawerStore(s => s.open);
  return useCallback(
    (invoiceId: string) => {
      if (!invoiceId) return;
      open(invoiceId);
    },
    [open],
  );
}
